<div class="flex-container">
    <div class="config-tab-title-area">
        <smart-icon name="visualization" class="light"></smart-icon>
        <span class="h3-regular config-tab-title">VISUALIZATION SETTINGS</span>
    </div>
    <div class="container">
        <div *ngFor="let setting of settings">
            <div class="row">
                <h4 *ngIf="setting.title">{{setting.title}}</h4>
            </div>
            <div class="tam-form-field grid">
                <div *ngFor="let field of setting.fields;" class="row-column" [ngStyle]="getStyle(field)">
                    <div *ngIf="field.type==='dropdown'">
                        <div class="tam-form-label row-column">
                            <span>{{field.displayName}} <span *ngIf="field.required"
                                    class="required-field">*</span></span>
                        </div>
                        <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}"
                            [(ngModel)]="data[field.propertyName]" [data]="field.options" textField="display"
                            valueField="value" [valuePrimitive]="true" [disabled]="field.disabled"
                            (valueChange)="onValueChanged($event,field.id)">
                        </kendo-dropdownlist>
                    </div>
                    <div *ngIf="field.type==='checkbox'" class="spacious-row">
                        <label tam-checkbox (checkedChange)="onCheckboxChange($event,field.id)"
                            [(ngModel)]="data[field.propertyName]">{{field.displayName}}</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>